import * as React from 'react';
import { HTMLProps, PureComponent } from 'react';
import { classNames } from '@tolkam/lib-utils-ui';
import Layer from '~/ui/react/components/Layer';
import './styles';

class Toast extends PureComponent<IProps, IState> {

    /**
     * @inheritDoc
     */
    public static defaultProps = {
        autoClose: true,
        autoCloseAfter: 5000,
    };

    /**
     * @type IState
     */
    public state = {
        show: false,
    };

    /**
     * Timeout id
     */
    protected tId: any;

    /**
     * @inheritDoc
     */
    public componentDidUpdate(prevProps: IProps): void {
        const that = this;
        const { children } = that.props;

        if(!that.state.show && children && children !== prevProps.children) {
            that.open();
        }
    }

    /**
     * @inheritDoc
     */
    public componentWillUnmount(): void {
        clearTimeout(this.tId);
    }

    /**
     * @inheritDoc
     */
    public render() {
        const that = this;
        const { props } = that;
        const baseClassName = 'jc-toast';
        const { mode } = props;
        const classes = classNames(baseClassName, {
            ['-error']:    mode === 'error',
            ['-success']: mode === 'success',
            ['-info']: mode === 'info',
        }, props.className);

        return <Layer
            show={that.state.show}
            onCloseRequest={that.close}
            onClose={props.onClose}
            mode="popup"
            className={classes}
            noFocus
            withHistory={false}
        >{props.children}</Layer>
    }

    /**
     * Opens the layer
     *
     * @return void
     */
    protected open = () => {
        const that = this;
        const { props } = that;

        const cb = props.autoClose ? () => {
            clearTimeout(that.tId);
            that.tId = setTimeout(that.close, props.autoCloseAfter);
        } : undefined;

        that.setState({
            show: true,
        }, cb);
    };


    /**
     * Closes the layer
     *
     * @return void
     */
    protected close = () => {
        this.setState({
            show: false,
        });
    }
}

interface IProps extends HTMLProps<HTMLDivElement> {
    // display modes
    mode: 'error' | 'success' | 'info';
    autoClose?: boolean;
    autoCloseAfter?: number;
    onClose?: () => void;
}

interface IState {
    show: boolean,
}

export default Toast;
